import type { RigaPreventivoLetta } from '../../api/preventivi';

/*  I CAMPI DELLA RIGA CHE SI CORREGGONO A MANO.

    Sono i nove che la cella tiene in uno stato suo mentre qualcuno ci scrive dentro,
    prima di premere «Salva la riga». Tutto il resto della riga — il prezzo, lo sconto
    ereditato, il livello — lo decide il conto o l'albero, e nessuno lo batte.

    L'elenco sta qui e non sparso nel componente perché serve a due domande diverse:
    «questa riga è stata toccata?» e «questa riga è cambiata sul server?». Erano due
    elenchi e sarebbero divergiti al primo campo aggiunto.
*/
export const CampiCorreggibili = [
  'descrizione',
  /*  La sigla e il codice del produttore: dal 04/10/2026 si scrivono anche su una riga
      battuta a mano, e non arrivano piu' solo dal catalogo. Senza di loro qui dentro, una
      riga a cui si e' appena scritto il codice si sarebbe riallineata al primo
      salvataggio di un'altra riga, buttando via quello che era stato battuto.  */
  'siglaProduttore',
  'codiceArticoloProduttore',
  'unitaMisura',
  'quantita',
  'prezzoListinoUnitario',
  'costoUnitarioMateriale',
  'oreUnitarie',
  'posaACorpo',
  'ricaricoSpecificoPercentuale',
  'scontoClientePercentuale',
] as const satisfies readonly (keyof RigaPreventivoLetta)[];

/*  Due letture della stessa riga dicono la stessa cosa?

    Serve a distinguere «è arrivata una riga nuova perché QUESTA è cambiata» da «è
    arrivato un oggetto nuovo perché si è riletto il preventivo». Sembra una sottigliezza
    e non lo è: dopo ogni salvataggio il documento si rilegge INTERO, quindi ogni riga
    arriva come oggetto nuovo anche se il suo contenuto non si è mosso di un centesimo.

    Il 28/09/2026 quella differenza è costata un difetto vero: si scrivevano le quantità
    su due righe, se ne salvava una, e l'altra tornava a zero perdendo quello che era
    stato battuto — senza nemmeno restare marcata come «da salvare», quindi senza un
    segnale che fosse successo qualcosa.
*/
export function stessiValoriCorreggibili(
  una: RigaPreventivoLetta,
  altra: RigaPreventivoLetta,
): boolean {
  return una.id === altra.id && CampiCorreggibili.every((campo) => una[campo] === altra[campo]);
}
